import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, SimpleChanges, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ColorPickerModule } from 'ngx-color-picker';
import { Subscription } from 'rxjs';
import { Drilllog } from 'src/app/bo/geology/drilllog';
import { ProprieteAffichee } from 'src/app/bo/proprieteAffichee';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';

@Component({
  selector: 'app-drilllog-gui',
  templateUrl: './drilllog-gui.component.html',
  styleUrls: ['./drilllog-gui.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, ColorPickerModule]
})
export class DrilllogGuiComponent implements OnInit {
  readonly currentRegionId = input<number>(undefined);
  readonly isAdminOrResReg = input<boolean>(false);


  table_width = signal<number[]>([8,23,23,23,7,6,6]);

  showErrorModif = signal(false);
  showErrorNew = signal(false);

  tabDrilllogs = signal<Drilllog[]>([]);
  selectedDrillLog = signal(new Drilllog());
  oldDrillLog = signal(new Drilllog());

  newDrillLog = signal(new Drilllog());
  proprietesAffichees = signal<ProprieteAffichee[]>([]);

  isModifiable = signal(-1);
  lastToucheIndex = signal(-1);
  isFooterFocus = signal(false);
  currentRegionSubscription: Subscription;



  constructor(
     private readonly http: HttpService,
     public utilService: UtilisateurService,
     private readonly fonctionsService: FonctionsService
     ) {
       this.proprietesAffichees.set(new Drilllog().getProprietesAffichees());
    }
  

  ngOnInit(): void {
    this.getDiscontinuitiesByRegionId();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['currentRegionId']){
      this.getDiscontinuitiesByRegionId();
    }
    
  }



  protected selectDrillLog(drilllog: Drilllog, index:number, e:any){
    if(this.selectedDrillLog().id === drilllog.id) return;

    if(this.lastToucheIndex() > -1 && this.oldDrillLog().id > 0 ){
      const currentLogs = this.tabDrilllogs();
      currentLogs[this.lastToucheIndex()] = this.oldDrillLog();
      this.tabDrilllogs.set(currentLogs);
    }

    this.lastToucheIndex.set(index);
    this.oldDrillLog.set(Object.assign({}, drilllog));

    this.selectedDrillLog.set(Object.assign({}, drilllog));
    this.isModifiable.set(index);
    this.clearNew();
  }

  protected clearNew(){
    this.newDrillLog.set(new Drilllog());
    this.isFooterFocus.set(false);

  }
  protected clearSelected(){
    this.selectedDrillLog.set(new Drilllog());
  }

  protected newDrillLogChange(){
    this.selectedDrillLog.set(new Drilllog());
    this.isModifiable.set(-1);
    this.isFooterFocus.set(true);
  }

  protected onFocusOutEvent(){
    this.isFooterFocus.set(false);
  }

  protected toggleIsActive(d: Drilllog) {
    const newState = !d.isActive;
    const url = `Geology/site/toggle/discontinuity/${d.id}?isActive=${newState}`;
    this.http.put(url, {}).subscribe({
      next: () => {
        d.isActive = newState;
        this.tabDrilllogs.set([...this.tabDrilllogs()]);
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
      }
    });
  }

  private getDiscontinuitiesByRegionId(){
    let regionId = this.currentRegionId();
    if (regionId == undefined){
      regionId = this.utilService.currentRegionForSetupRegion.regionId;
    }

    this.fonctionsService.loading_screen(true);
    
    if(regionId === undefined) return;

    const url = "Geology/GetAllDiscontinuitiesByRegionId/" + regionId;

    this.http.get<Drilllog[]>(url).subscribe({
     next: result =>{
      this.tabDrilllogs.set(result);
    } ,
    error: (error: HttpErrorResponse) => {
      if(error.status === 401 || error.status === 403){
    console.log(error.error);
      }
      this.fonctionsService.launch_toast(false);
      this.fonctionsService.loading_screen(false);
    },
    complete:() => {
       this.fonctionsService.loading_screen(false);
     }
   })
  }


  protected createDiscontinuity(){
    const newLog = this.newDrillLog();
    if(newLog.name === '' || newLog.shortName === ''){
        this.showErrorNew.set(true);
        setTimeout(() => {
        this.showErrorNew.set(false);
      }, 1500);
      return;
    }

    this.fonctionsService.loading_screen(true);
    const updatedLog = {...newLog, regionId: this.currentRegionId()};
    const url = "Geology/CreateDiscontinuity";
    this.http.post(url, updatedLog).subscribe({
     next: result =>{
      this.clearNew();
      this.clearSelected();
      this.getDiscontinuitiesByRegionId();
      this.fonctionsService.launch_toast(true);
      this.fonctionsService.loading_screen(false);
     } ,
     error: (error: HttpErrorResponse) => {
      if(error.status === 401 || error.status === 403){
    console.log(error.error);
      }
      this.fonctionsService.launch_toast(false);
      this.fonctionsService.loading_screen(false);
     },
     complete:() => {
      this.fonctionsService.loading_screen(false);
     }
   })
  }

  protected update(d:Drilllog, index:number){
    if(d.name === '' || d.shortName === ''){
      this.showErrorModif.set(true);
      setTimeout(() => {
      this.showErrorModif.set(false);
    }, 1500);
    return;
  }

      this.updateApi(this.tabDrilllogs()[index]).subscribe({
        next: result =>{
          this.clearNew();
          this.clearSelected();
          this.oldDrillLog.set(new Drilllog());
          this.lastToucheIndex.set(-1);
          this.isModifiable.set(-1);
          this.fonctionsService.loading_screen(false);
          this.fonctionsService.launch_toast(true);
        } ,
        error: (error: HttpErrorResponse) => {
          if(error.status === 401 || error.status === 403){
        console.log(error.error);
          }
          this.fonctionsService.launch_toast(false);
          this.fonctionsService.loading_screen(false);
        },
        complete:() => {
          this.fonctionsService.loading_screen(false);
        }
      })
  }

  protected delete(selectedDrillog:Drilllog){
    const updatedDrillog = Object.assign(new Drilllog(), selectedDrillog, { regionId: 0 });
      this.updateApi(updatedDrillog).subscribe({
        next: result =>{
         this.clearNew();
         this.clearSelected();
         this.oldDrillLog.set(new Drilllog());
         this.lastToucheIndex.set(-1);
         this.isModifiable.set(-1);
         this.fonctionsService.loading_screen(false);
         this.tabDrilllogs.set(this.tabDrilllogs().filter((item) => item.id !== selectedDrillog.id));
         this.fonctionsService.launch_toast(true);
        } ,
        error: (error: HttpErrorResponse) => {
         if(error.status === 401 || error.status === 403){
       console.log(error.error);
         }
         this.fonctionsService.launch_toast(false);
         this.fonctionsService.loading_screen(false);
        },
        complete:() => {
         this.fonctionsService.loading_screen(false);
        }
      })
  }

  private updateApi(selectedDrillog:Drilllog){
    this.fonctionsService.loading_screen(true);
    const url = "Geology/UpdateDiscontinuity";
    return this.http.put(url, selectedDrillog)
  }
}
